<template>
  <div class="weather-fill clearfix">
    <el-form ref="Formlist" :model="datalist" label-width="100px" class="demo-fillForm">
<!--       <ep-title title="风险等级">
        <el-form-item prop="industryType ">
          <el-select v-model="datalist.riskLevel" placeholder="请选择风险等级" @change="changetype">
            <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
      </ep-title>
      <div class="risky">
        <ep-title title="风险物质">
          <el-upload class="upload-demo1" action="/api/emer/sudden/import/riskmaterial" :on-preview="handlePreview" :on-success="onSuccess">
            <el-button size="small" style="width:100px">导入</el-button>
          </el-upload>
          <el-button size="small" style="width:100px" @click="exportRisk">下载导入模板</el-button>
        </ep-title>
        <div class="measure-table">
          <el-table :data="datalist.riskyMaterial" style="width: 100%">
            <el-table-column label="序号" width="80" header-align="center" align="center" type="index">
            </el-table-column>
            <el-table-column label="名称">
              <template slot-scope="scope">
                <el-input size="small" placeholder="" v-model="scope.row.name"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="形态">
              <template slot-scope="scope">
                <el-select v-model="scope.row.state" placeholder="请选择" size="small">
                  <el-option v-for="item in option" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="数量">
              <template slot-scope="scope">
                <el-input size="small" placeholder="" v-model="scope.row.count"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="单位">
              <template slot-scope="scope">
                <el-input size="small" placeholder="" v-model="scope.row.unit"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="储存方式">
              <template slot-scope="scope">
                <el-input size="small" placeholder="" v-model="scope.row.storage"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope" align="center">
                <i class="el-icon-delete" @click="removeRow(scope)"></i>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <p class="add-p" @click="addDomain">+ 添加数据</p>
      </div> -->
      <div class="risky">
        <ep-title title="应急物资">
          <el-upload class="upload-demo1" action="/api/emer/sudden/import/emermaterial" :headers="headers" :on-preview="handlePreview" :on-success="onSuccessemer">
            <el-button size="small" style="width:100px">导入</el-button>
          </el-upload>
          <el-button size="small" style="width:100px" @click="exportEmer">下载导入模板</el-button>
        </ep-title>
        <div class="measure-table">
          <el-table :data="datalist.emergencyMaterial" style="width: 100%">
            <el-table-column label="序号" width="80" header-align="center" align="center" type="index">
            </el-table-column>
            <el-table-column label="名称">
              <template slot-scope="scope">
                <el-input size="small" placeholder="" v-model="scope.row.name"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="作用">
              <template slot-scope="scope">
                <el-input size="small" placeholder="" v-model="scope.row.function"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="数量">
              <template slot-scope="scope">
                <el-input size="small" placeholder="" v-model="scope.row.count"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="放置场所">
              <template slot-scope="scope">
                <el-input size="small" placeholder="" v-model="scope.row.location"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="使用部门">
              <template slot-scope="scope">
                <el-input size="small" placeholder="" v-model="scope.row.department"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope" align="center">
                <i class="el-icon-delete" @click="removeRowMaterial(scope)"></i>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <p class="add-p" @click="addMaterial">+ 添加数据</p>
      </div>
      <div class="risky">
        <ep-title title="敏感保护目标">
        </ep-title>
        <div class="measure-table">
          <el-table :data="datalist.sensitiveProtection" style="width: 100%">
            <el-table-column label="序号" width="80" header-align="center" align="center" type="index">
            </el-table-column>
            <el-table-column label="类型">
              <template slot-scope="scope">
                <el-select v-model="scope.row.type" placeholder="请选择" size="small">
                  <el-option v-for="item in optionType" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="名称">
              <template slot-scope="scope">
                <el-input size="small" placeholder="" v-model="scope.row.name"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="坐标" width="300">
              <template slot-scope="scope">
                <p class="inp-p">
                  东经：{{scope.row.longitude | formatDegree}}，北纬：{{scope.row.latitude | formatDegree}}
<!--                  <el-input size="small" placeholder="经度" v-model="scope.row.longitude"></el-input>-->
<!--                  <el-input size="small" placeholder="纬度" v-model="scope.row.latitude"></el-input>-->
                </p>
                <el-button size="small" @click="showMapBox(scope.$index)" class="but-small">地图选点</el-button>
                <mapPointer :show="showMap" :source='{lat:scope.row.latitude,lng:scope.row.longitude}' :data-index='scope.$index' ref='mapPointer' @change="confirm"></mapPointer>
              </template>
            </el-table-column>
            <el-table-column label="描述">
              <template slot-scope="scope">
                <el-input size="small" placeholder="" v-model="scope.row.description"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope" align="center">
                <i class="el-icon-delete" @click="removeProtection(scope)"></i>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <p class="add-p" @click="addProtection">+ 添加数据</p>
      </div>
    </el-form>
  </div>
</template>
<script>
import emissTable from '../../components/weather/emissTable'
import measureTable from '../../components/weather/measureTable'
import emer from '../../data/emer/weather.js'
import burst from '../../data/emer/burst.js'
import mapPointer from '../../view/component/MapPointer.vue'
import Apis from '../../data/api';
export default {
  data() {
    return {
        isValidateForm: true,
      option: [{
        value: '1',
        label: '固态'
      }, {
        value: '2',
        label: '液态'
      }, {
        value: '3',
        label: '气态'
      }],
      optionType: [{
        value: '1',
        label: '学校'
      }, {
        value: '2',
        label: '医院'
      }, {
        value: '3',
        label: '村庄'
      }, {
        value: '4',
        label: '社区'
      }, {
        value: '5',
        label: '水源地'
      }],
      value: '',
      datalist: {
        emergencyMaterial: [{
          count: '',
          department: '',
          function: '',
          location: '',
          name: ''
        }],
        // 应急物资 ,
        planId: '',
        // 预案Id ,
        sensitiveProtection: [{
          description: '',
          // 描述 ,
          latitude: '',
          // 纬度 ,
          longitude: '',
          // 经度 ,
          name: '',
          // 名称 ,
          type: ''
          // 类型 ， 1=学校，2=医院，3=村庄，4=社区，5=水源地
        }]
        // 重点保护目标
      },
      options: '',
      measureStateName: [{
          value: 'SO2',
          label: '二氧化硫'
        },
        {
          value: 'Dust',
          label: '烟、粉尘'
        },
        {
          value: 'NOx',
          label: '氮氧化物'
        },
        {
          value: 'VOCs',
          label: 'VOCs(挥发性有机物质)'
        },
      ],
      listobj: [],
      showMap: {
        state: false
      },
      latlng: {
        lat: '',
        lng: ''
      },
      latlngnum: '',
      currIndex: -1
    };
  },
  // created() {
  //   // this.getTypelist()
  // },
    created () {
        Apis.getEnv().then((resp) => {
            this.isValidateForm = resp.isValidate;
            if (typeof resp.isValidate === "string") {
                this.isValidateForm = resp.isValidate === "true" ? true : false;
            }
        });
    },
  methods: {
    showMapBox(index) {
      this.currIndex = index
      this.showMap.state = true
    },
    submitForm(formName) {
        if(!this.isValidateForm) {
            this.$emit('change', this.datalist)
            return true
        }
      for (let i = 0; i < this.datalist.emergencyMaterial.length; i++) {
          if (this.datalist.emergencyMaterial[i].name == '') {
            this.$message.error('请填写第' + ++i + '行应急物资的名称')
            return
          }
          if (this.datalist.emergencyMaterial[i].function == '') {
            this.$message.error('请填写第' + ++i + '行应急物资的作用')
            return
          }
          if (this.datalist.emergencyMaterial[i].location == '') {
            this.$message.error('请填写第' + ++i + '行应急物资的放置场所')
            return
          }
          if (this.datalist.emergencyMaterial[i].department == '') {
            this.$message.error('请填写第' + ++i + '行应急物资的使用部门')
            return
          }
          if (this.datalist.emergencyMaterial[i].count == '') {
            this.$message.error('请填写第' + ++i + '行应急物资的数量')
            return
          }
      }
     for (let i = 0; i < this.datalist.sensitiveProtection.length; i++) {
        if (this.datalist.sensitiveProtection[i].description == '') {
          this.$message.error('请填写第' + ++i + '行敏感保护目标的相关描述')
          return
        }
        if (this.datalist.sensitiveProtection[i].latitude == '' || this.datalist.sensitiveProtection[i].longitude == '') {
          this.$message.error('请选择第' + ++i + '行敏感保护目标的坐标')
          return
        }
        if (this.datalist.sensitiveProtection[i].name == '') {
          this.$message.error('请填写第' + ++i + '行敏感保护目标的名称')
          return
        }
        if (this.datalist.sensitiveProtection[i].type == '') {
          this.$message.error('请选择第' + ++i + '行敏感保护目标的类型')
          return
        }
     }
     // if (this.datalist.riskyMaterial.length == 0) {
     //  this.$message.error('风险物质不能为空')
     //  return
     // }
          if (this.datalist.emergencyMaterial.length == 0) {
      this.$message.error('应急物资不能为空')
      return
     }
          if (this.datalist.sensitiveProtection.length == 0) {
      this.$message.error('敏感保护目标不能为空')
      return
     }
      this.datalist.planId = sessionStorage.planIdval
      // for (var i = 0; i < this.datalist.riskyMaterial.length; i++) {
      //   for (var k = 0; k < this.option.length; k++) {
      //     if (this.datalist.riskyMaterial[i].state == this.option[k].label) {
      //       this.datalist.riskyMaterial[i].state = this.option[k].value
      //     }
      //   }
      // }
      this.$refs['Formlist'].validate((valid) => {
        if (valid) {
          this.$emit('change', this.datalist)
          return true
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 风险等级
    // getTypelist(params) {
    //   (async() => {
    //     let getState = await burst.risklevel_list(params)
    //     if (getState.status) {
    //       this.options = getState.data
    //     }
    //   })()
    // },
    // 下拉选中的数据类型
    // changetype(val) {
    //   this.datalist.riskLevel = val
    // },
    // 添加风险物质
    // addDomain() {
    //   this.datalist.riskyMaterial.push({
    //     count: '',
    //     name: '',
    //     state: '',
    //     storage: '',
    //     unit: ''
    //   })
    //     console.log(this.datalist.riskyMaterial.length, 1111111)
    // },
    // 添加应急物资
    addMaterial() {
      this.datalist.emergencyMaterial.push({
        count: '',
        department: '',
        function: '',
        location: '',
        name: ''
      })
    },
    // 添加敏感保护目标
    addProtection() {
      this.datalist.sensitiveProtection.push({
        description: '',
        latitude: '',
        longitude: '',
        name: '',
        type: ''
      })
    },
    // 删除应急
    removeRowMaterial(row) {
      this.datalist.emergencyMaterial.splice(row.$index, 1)
    },
    // 删除敏感
    removeProtection(row) {
      this.datalist.sensitiveProtection.splice(row.$index, 1)
    },
    // 执行确认操作
    confirm(val) {
      this.datalist.sensitiveProtection[this.currIndex].latitude = Math.floor(val.lat * 1000000) / 1000000
      this.datalist.sensitiveProtection[this.currIndex].longitude = Math.floor(val.lng * 1000000) / 1000000
    },
    // 下载风险物资
    exportRisk() {
      window.location.href = '/api/emer/sudden/export/riskmaterial'
    },
    // 下载应急物资
    exportEmer() {
      window.location.href = '/api/emer/sudden/export/emermaterial'
    },
    handlePreview(file) {
      // console.log(file);
    },
    // 风险物资导入
    // onSuccess(response, file, fileList) {
    //   this.datalist.riskyMaterial = response
    //   for (var i = 0; i < this.datalist.riskyMaterial.length; i++) {
    //     for (var k = 0; k < this.option.length; k++) {
    //       if (this.datalist.riskyMaterial[i].state == this.option[k].value) {
    //         this.datalist.riskyMaterial[i].state = this.option[k].label
    //       }
    //     }
    //   }
    // },
    // 应急物资导入
    onSuccessemer(response, file, fileList) {
      this.datalist.emergencyMaterial = response
    },
  },
  components: {
    emissTable,
    measureTable,
    mapPointer
  },
  computed:{
    headers(){
      return {
        'Authorization': 'Bearer '+ sessionStorage.getItem('publicToken')
      }
    }
  },
}

</script>
<style scoped>
.weather-fill {
  text-align: left;
  margin: 20px 30px 0 30px;
}

.measure-table {
  width: 100%;
  height: auto;
  position: relative;
  margin-top: 20px;
}

.add-p {
  font-size: 14px;
  margin: 10px 0;
  cursor: pointer;
  color: #20a0ff;
}

.but-small {
  float: left;
  width: 75px!important;
  height: 30px;
  margin-left: 5px;
}

.el-icon-delete {
  font-size: 20px
}

.el-icon-delete:hover {
  color: #20a0ff;
}

.inp-p {
  display: inline-block;
  width: 185px;
  height: 30px;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #bfcbd9;
  box-sizing: border-box;
  float: left;
  background: #fff;
}

.upload-demo1 {
  float: left;
  margin-right: 10px;
}

</style>



// WEBPACK FOOTER //
// GovFillInfo.vue?06a1dbc6